import React from 'react'
import { TemplatesContextProvider } from '../context/TemplatesContext'

export const withTemplatesListContext = (Component: React.FC) => {
  return (props: any) => {
    return (
      <TemplatesContextProvider>
        <Component {...props} />
      </TemplatesContextProvider>
    )
  }
}
